import script from "./notFound.vue?vue&type=script&setup=true&lang=js"
export * from "./notFound.vue?vue&type=script&setup=true&lang=js"

import "./notFound.vue?vue&type=style&index=0&id=06587ab2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06587ab2"]])

export default __exports__